import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import MenuNavBar from './MenuNavBar';


const StyledMenu = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  background-color: white;
  z-index: ${({ theme }) => theme.zIndex.modalMenu};

  @media (min-width: ${({ theme }) => theme.breakpoints.md + 1}px) {
    display: none;
  }
`;

const CloseButton = styled.div`
  position: fixed;
  top: 30px;
  right: 40px;
  font-size: 28px;
  font-weight: bold;
`;

const Menu = ({
  className,
  items,
  onClose,
}) => {
  const classes = [];
  if (className) classes.push(className);

  function handleClick(e) {
    e.stopPropagation();
    onClose(e);
  }

  return (
    <StyledMenu className={classes.join(' ')}>
      <CloseButton>
        <FontAwesomeIcon icon={faTimes} onClick={handleClick} />
      </CloseButton>
      <MenuNavBar onClick={handleClick} items={items} />
    </StyledMenu>
  );
};

Menu.displayName = 'Menu';

Menu.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

Menu.defaultProps = {
  className: null,
};

export default Menu;
